import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface ComposeCoAuthorData {
    deleted: boolean;
    email: string;
    firstName?: string;
    id: number;
    index: number;
    isMember: boolean;
    isNew?: boolean;
    lastName?: string;
    profilePicture?: string;
    title?: string;
    userId: number;
}

export class ComposeCoAuthor implements FormValidationModel<ComposeCoAuthorData> {
    public data: ComposeCoAuthorData;
    public rules: yup.Schema<ComposeCoAuthorData>;

    public constructor() {
        this.data = {
            ...DefaultComposeCoAuthor,
        };
        this.rules = yup.object<ComposeCoAuthorData>().shape({
            deleted: yup.bool(),
            email: yup.string().email().label("Email address").required(),
            firstName: yup.string().label("First name").max(50),
            id: yup.number().label("Co author ID").min(0, "Invalid $label"),
            isMember: yup.bool().label("Is member"),
            index: yup.number(),
            lastName: yup.string().label("Last name").max(50),
            profilePicture: yup.string().nullable(true).label("Profile picture"),
            title: yup.string().nullable(true).label("Title").max(100),
            userId: yup.number().label("Co author user ID").min(0, "Invalid $label"),
        });
    }
}

export const ComposeCoAuthorSchema = new ComposeCoAuthor().rules;

export const DefaultComposeCoAuthor: ComposeCoAuthorData = {
    deleted: false,
    id: 0,
    isMember: false,
    index: 0,
    email: "",
    userId: 0,
};



// WEBPACK FOOTER //
// ./src/forms/abstract/ComposeCoAuthor.ts